import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CrossSVG } from '@snack-uikit/icons';
import { BUTTON_SIZE } from '../constants';
import styles from './styles.module.css';
export const ButtonClearValue = forwardRef(({ size, onClick, tabIndex = -1, onKeyDown }, ref) => {
    const handleClick = event => {
        event.stopPropagation();
        onClick(event);
    };
    return (_jsxs("button", { className: styles.buttonClearValue, "data-size": size, onClick: handleClick, "data-test-id": 'button-clear-value', type: 'button', ref: ref, onKeyDown: onKeyDown, tabIndex: tabIndex, children: [size === BUTTON_SIZE.S && _jsx(CrossSVG, { size: 16 }), size === BUTTON_SIZE.M && _jsx(CrossSVG, {})] }));
});
